import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'kt-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent {
  @Input() isRange: boolean;
  @Input() min: number;
  @Input() max: number;
  @Input() step = 1;
  @Input() startColor:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'neutral' = 'neutral';
  @Input() endColor:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'neutral' = 'neutral';
  @Input() control: FormControl; // control value type { start: number; end?: number }
  @Input() formatter?: { label?: (value: number) => string; value?: (value: number) => string } = {
    label: (value: number) => `${value}`,
    value: (value: number) => `${value}`,
  };

  handleStartInput(value: number): void {
    this.control.setValue({ ...this.control.value, start: value });
  }

  handleStartChange(value: number): void {
    const ctrlVal = this.control.value;

    if (this.isRange && value > ctrlVal.end) {
      setTimeout(() => {
        this.control.setValue({ ...ctrlVal, start: ctrlVal.end - 1 });
      });
    }
  }

  handleEndInput(value: number): void {
    this.control.setValue({ ...this.control.value, end: value });
  }

  handleEndChange(value: number): void {
    const ctrlVal = this.control.value;

    if (this.isRange && value < ctrlVal.start) {
      setTimeout(() => {
        this.control.setValue({ ...ctrlVal, end: ctrlVal.start + 1 });
      });
    }
  }
}
